module.exports = __webpack_public_path__ + "static/img/dnzlzz.dcdb9e91.png";